<template>
  <div class="login-wrap">
    <el-card class="login-card">
      <h2>社区后台登录</h2>
      <el-form ref="form" :model="form">
        <el-form-item label="账号">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" type="password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doLogin">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import {adminLogin} from "../api";
export default {
  data(){
    return {
      form:{username:'',password:''}
    }
  },
  methods:{
    async doLogin(){
      const res = await adminLogin(this.form)
      if(res.data.code === 200){
        localStorage.setItem('admin_token',res.data.token)
        this.$router.push('/dashboard')
        this.$message.success('登录成功')
      }else{
        this.$message.error(res.data.msg)
      }
    }
  }
}
</script>
<style scoped>
.login-wrap{height:100vh;display:flex;align-items:center;justify-content:center;background:#f5f7fa}
.login-card{width:360px}
</style>
